module.exports = __webpack_public_path__ + "img/AF.2206771b.svg";